/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { toast } from 'react-toastify';
import ToggleButton from 'react-toggle-button';
/** toggle button component
 * @param {boolean} sameSides - show same colors on active and inactive
 * @param {boolean} disabled - disable toggle
 * @param {boolean} customDisableText - to display custom toggle when toggle is disabled.
 */

import './index.css';

const styleHeight = { height: '2rem' };

const redSides = {
  activeThumb: {
    base: '#dc3545',
  },
  inactiveThumb: {
    base: '#a5b5db',
  },
  active: {
    base: '#dee6fa',
  },
  inactive: {
    base: '#dee6fa',
  },
};

const greenSides = {
  activeThumb: {
    base: '#ffffff',
  },
  inactiveThumb: {
    base: '#a5b5db',
  },
  active: {
    base: '#4BB544',
  },
  inactive: {
    base: '#dee6fa',
  },
};

const Toggle = props => {
  const { left, right } = props;
  const sameSides = {
    activeThumb: {
      base: 'rgb(59, 90, 169)',
    },
    inactiveThumb: {
      base: 'rgb(59, 90, 169)',
    },
    active: {
      base: '#dee6fa',
    },
    inactive: {
      base: '#dee6fa',
    },
  };

  const disabledStyle = {
    activeThumb: {
      base: 'rgb(59, 90, 169)',
    },
    inactiveThumb: {
      base: '#a5b5db',
    },
    active: {
      base: '#dee6fa',
    },
    inactive: {
      base: '#dee6fa',
    },
  };
  const faxDisabledStyle = {
    activeThumb: {
      base: '#8f98a8',
    },
    inactiveThumb: {
      base: '#8f98a8',
    },
    active: {
      base: '#d9deea',
    },
    inactive: {
      base: '#d9deea',
    },
  };

  const defaultStyle = {
    activeThumb: {
      base: 'rgb(59, 90, 169)',
    },
    inactiveThumb: {
      base: '#a5b5db',
    },
    active: {
      base: '#dee6fa',
    },
    inactive: {
      base: '#dee6fa',
    },
  };
  return (
    <div className="d-flex justify-content-between align-items-center">
      {left ? (
        <p style={styleHeight} className="d-flex align-items-end mr-1">
          {left}
        </p>
      ) : null}
      <ToggleButton
        colors={
          props.sameSides
            ? sameSides
            : props.redSides
            ? redSides
            : props.faxDisabled
            ? faxDisabledStyle
            : props.disabled
            ? disabledStyle
            : props.greenSides
            ? greenSides
            : defaultStyle
        }
        animateThumbStyleHover={n => {
          return {
            boxShadow: `0 0 ${2 + 4 * n}px rgba(0,0,0,.16),0 ${2 + 3 * n}px ${4 +
              8 * n}px rgba(0,0,0,.32)`,
          };
        }}
        containerStyle={{ width: '50px' }}
        trackStyle={{
          width: '50px',
          height: '23px',
        }}
        thumbStyle={{ height: '16px', width: '16px' }}
        thumbAnimateRange={[4, 30]}
        inactiveLabel=""
        activeLabel=""
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        onToggle={
          props.disabled
            ? () => {
                toast.info(`${props?.customDisableText || 'You do not have sufficient permissions to perform this function.'}`);
              }
            : props.onToggle
        }
      />
      {right ? (
        <p style={styleHeight} className="d-flex align-items-end ml-1">
          {right}
        </p>
      ) : null}
    </div>
  );
};

export default Toggle;
